/**
 * Strict validation for publicSites/{slug} before rendering public client UI.
 */
export function validatePublicSiteDocumentForClient(raw, slug) {
  if (!raw || typeof raw !== 'object') {
    return { ok: false, reason: 'Datele locației nu sunt disponibile.' };
  }

  const merchantUid = String(raw.merchantUid || '').trim();
  if (!merchantUid) {
    return { ok: false, reason: 'Configurația locației este incompletă.' };
  }

  const expectedSlug = String(slug || '').trim().toLowerCase();
  const publicSlug = String(raw.publicSlug || '').trim().toLowerCase();
  if (expectedSlug && publicSlug && expectedSlug !== publicSlug) {
    return { ok: false, reason: 'Acest link nu mai este valid pentru locația curentă.' };
  }

  return { ok: true };
}
